export default __webpack_public_path__ + "static/media/arrowdownred.7fc2c925.svg";